import React, { useState, useEffect } from 'react';
import { NoRecords, PageLoader } from '../../lib/loader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ArrowDown, ArrowUp, View } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useCoreAddressList } from './api/index';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import { WaitingLoader } from '../../hooks/buttonLoad';

function CoreWalletBalance() {
    const navigate = useNavigate();
    const [page] = useState(0);
    const [rowsPerPage] = useState(10);
    const [search] = useState('');
    const [sortOrder, setSortOrder] = useState('desc');
    const searchText = useDebounce(search);
    const { data: getCoreList, isLoading, error } = useCoreAddressList({
        page,
        size: rowsPerPage,
        sortOrder: sortOrder,
        searchText,
        sortField: '_id',
    });

    const handleEdit = (currencyName) => {
        navigate(`/corewalletbalance/${currencyName}`);
    };

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'Core wallet' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const list = () => {
        if (isLoading) {
            return <PageLoader />;
        }
        if (error) {
            return <div>Error loading data: {error.message}</div>;
        }
        if (!getCoreList?.data?.data || getCoreList?.data?.data?.length === 0) {
            return <NoRecords />;
        }
        return (

            <div style={{ minHeight: '60vh' }}>
                <div className='table-responsive'>
                    <Table sx={{ minWidth: 650 }} aria-label="core wallet balance table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ maxWidth: '60px' }} align="center">
                                    S.NO
                                </TableCell>
                                <TableCell align="center">Currency Name</TableCell>
                                <TableCell align="center">Address</TableCell>
                                <TableCell align="center">Balance</TableCell>
                                <TableCell align="center">
                                    Updated Date & Time{' '}
                                    {sortOrder !== 'desc' ? (
                                        <ArrowUp
                                            onClick={() => setSortOrder('desc')}
                                            style={{ cursor: 'pointer' }}
                                            aria-label="Sort descending"
                                        />
                                    ) : (
                                        <ArrowDown
                                            onClick={() => setSortOrder('asc')}
                                            style={{ cursor: 'pointer' }}
                                            aria-label="Sort ascending"
                                        />
                                    )}
                                </TableCell>
                                <TableCell align="center">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {getCoreList?.data?.data?.map((row, i) => {
                                const currencyName = Object.keys(row)[0];
                                const { address, balance } = row[currencyName];
                                let displayBalance;
                                if (balance !== undefined) {
                                    displayBalance = Number.isInteger(balance)
                                        ? balance
                                        : balance.toFixed(12);
                                } else {
                                    displayBalance = "N/A";
                                }
                                return (
                                    <TableRow key={currencyName}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{currencyName}</TableCell>
                                        <TableCell align="center">{address}</TableCell>
                                        <TableCell align="center">
                                            {displayBalance}
                                        </TableCell>
                                        <TableCell align="center">
                                            {moment(row.updatedAt || new Date()).format('DD/MM/YYYY | hh:mm')}
                                        </TableCell>
                                        <TableCell align="center">
                                            <div className="d-flex justify-content-center">
                                                <View
                                                    className="mx-3"
                                                    size={20}
                                                    type="button"
                                                    onClick={() => handleEdit(currencyName)}
                                                    aria-label={`View ${currencyName}`}
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </div>
            </div>

        );
    };

    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <div>
                <h2>Core Wallet Balance</h2>
                <div className="ad_pg_bx bg-white">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="col-md-4"></div>
                    </div>
                    {list()}
                </div>
            </div>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;

}

export default CoreWalletBalance;